module.exports = __webpack_public_path__ + "bf9da4af76d4e112a3f97123bd66ccda.webp";